import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderAdminDelegate } from '../header-admindelegate';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import {formatAdminDelegate, formatDelegateRight} from '@core/_utils/tools.utils';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-edit-admindelegate',
    // standalone: true,
    templateUrl: './edit-admindelegate.component.html',
    styleUrls: ['./edit-admindelegate.component.scss'],
})
export class EditAdminDelegateComponent implements OnInit {
    public selectedResult: HeaderAdminDelegate;
    public resultResult: any[];

    public errorMessage = '';
    public errorLoaderDialog = false;

    @Input()
    public item: any;

    @Input()
    public delegateBase = [];

    @Input()
    public delegateList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();

    constructor(
        private translate: TranslateService,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
    ) {
        this.menu.display = true;
        this.selectedResult = new HeaderAdminDelegate();
    }

    ngOnInit() {
        this.getResult(this.item.id);
        this.commonService.checkReset();
    }

    private async getResult(id) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getadmindelegate', id ));
            this.resultResult = wRes.data.data;
            this.selectedResult.Clear();
            if (id !== 0) {
                this.loadResultData(this.resultResult[0]);
            }
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));	
        }
    }

    private loadResultData(adata) {
        this.selectedResult.load(adata);   
    }

    delete(data) {
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(result) {
        let wRes: any = {};
        const wdata = formatAdminDelegate(result);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updateadmindelegate', wdata ));
            this.onValidate.emit({ index: this.item.index, id: this.item.id, data: wRes.data });     
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        } 
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
